var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot3" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "bg-mask", class: { zoomIn: _vm.isB1Visible } }),
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "p1 delay3", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("维拉3，定义AI智慧生活")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay4", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("既能认识环境与人，又能连接万物")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay5", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("自身环境认知 | 人体动态识别 | 万物互联中枢")]
        ),
        _c(
          "div",
          {
            staticClass: "p2 price delay6",
            class: { fadeUp: _vm.isB1Visible }
          },
          [_vm._v("¥39,999元/套")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          { staticClass: "p1 delay1", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("全新升级的语音交互")]
        ),
        _c(
          "div",
          { staticClass: "p2 delay2", class: { fadeUp: _vm.isB2Visible } },
          [_vm._v("宛若与一位伙伴在交流")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay3", class: { fadeUp: _vm.isB2Visible } },
          [
            _c("p", [
              _vm._v(
                "经过精挑细选，为机器人赋予1种近乎真人般的语音。强大的语音识别引擎，能够轻松听到5米范围内的指令。"
              )
            ]),
            _c("p", [
              _vm._v(
                "遴选业界优秀麦克风，打造360度覆盖的6麦阵列，在你和维拉说话的时候，“他”时刻都能够判别你在哪个方位，回应更贴心。"
              )
            ])
          ]
        ),
        _c("div", { staticClass: "p4" }, [
          _c(
            "div",
            {
              staticClass: "item delay4",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("精选语音")]), _vm._m(0)]
          ),
          _c(
            "div",
            {
              staticClass: "item delay5",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("远场识别")]), _vm._m(1)]
          ),
          _c(
            "div",
            {
              staticClass: "item delay6",
              class: { fadeDown: _vm.isB2Visible }
            },
            [_c("p", [_vm._v("阵列支持")]), _vm._m(2)]
          )
        ])
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("黑科技的一次完美体现")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("如家人般，熟悉家中每个角落")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB3Visible } },
          [_vm._v("一键自主建图 | 随性定义位置 | 静默更新地图")]
        ),
        _c("div", {
          staticClass: "loading",
          class: { animation: _vm.isB3Visible }
        }),
        _vm.isMobile
          ? _c("img", {
              staticClass: "map",
              class: { animation: _vm.isB3Visible },
              attrs: {
                src: require("../../../assets/mobile/3-info-b3-img1.png")
              }
            })
          : _c("img", {
              staticClass: "map",
              class: { animation: _vm.isB3Visible },
              attrs: { src: require("../../../assets/web/3-info-b3-img1.png") }
            })
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("多模式人体认知")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB4Visible } },
          [_vm._v("懂你的一言一行，更懂你的心")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB4Visible } },
          [
            _c("img", {
              attrs: { src: require("../../../assets/web/3-info-b4-img1.png") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c(
        "div",
        { staticClass: "p1 deplay1", class: { fadeUp: _vm.isB5Visible } },
        [
          _c("img", {
            staticClass: "img1",
            attrs: { src: require("../../../assets/web/dialog1.png") }
          }),
          _c("img", {
            staticClass: "img2",
            attrs: { src: require("../../../assets/web/dialog2.png") }
          }),
          _c("img", {
            staticClass: "img3",
            attrs: { src: require("../../../assets/web/dialog3.png") }
          })
        ]
      ),
      _c(
        "div",
        {
          staticClass: "info-b5-robot3 delay4",
          class: { "info-b5-robot3-animation": _vm.isB5Visible }
        },
        [
          _c("img", {
            staticClass: "img4",
            class: { fadeDown: _vm.isB5Visible },
            attrs: { src: require("../../../assets/web/dialog4.png") }
          })
        ]
      )
    ]),
    _c("div", { attrs: { id: "info-b6" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB6Visible } }, [
          _c("img", {
            attrs: { src: require("../../../assets/web/3-info-b6-img1.png") }
          })
        ]),
        _c(
          "div",
          { staticClass: "p2 delay3", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("为机器人赋予灵魂")]
        ),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(4, function(n) {
            return _c("div", {
              staticClass: "item",
              class: ["delay" + n, "img" + n, { fadeDown: _vm.isB6Visible }]
            })
          })
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b7" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB7Visible } }, [
          _vm._v("连接爱，连接家")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB7Visible } },
          [_vm._v("享受每一次与家人的见面")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeUp: _vm.isB7Visible } },
          [_vm._v("远程看家 | 跟随视频 | 亲情陪伴")]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b8" } })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("1")]), _vm._v("种")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("5")]), _vm._v("米")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("b", [_vm._v("6")]), _vm._v("麦")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bf87b9d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf87b9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/3/info.vue
// module id = 2fre
// module chunks = 0